var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-new-card-body gl-py-0 gl-mx-n1 gl-mb-n2",attrs:{"data-testid":"related-items-tree"}},[_c('tree-root',{attrs:{"parent-item":_vm.parentItem,"children":_vm.children}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }